import React from "react";
import { Formik, Form } from "formik";
import styled from "styled-components";

import { FileUpload } from "../FormInputs/FileUpload";
import { Submit } from "../FormInputs/Submit";
import { FormHeading } from "../FormHeading";

export const ResourceProjectFormStyled = styled.div`
	background-color: white;
	padding: ${(props) => props.theme.space.sm_2};
`;

export const ResumeForm = ({
	document,
	onSubmit,
	isSubmitting,
	initialValues,
	values,
	title,
	index,
	onSave,
	...props
}) => {
	let testId = props?.testId;

	// Ensure we have correct initial values structure
	const formInitialValues = {
		resume: initialValues?.resume_files || initialValues?.resume_file || "",
		is_default: initialValues?.is_default || "0",
	};

	// Handle the form submission and prepare the correct data structure
	const handleSubmit = (values) => {
		// Make sure we have a file
		if (!values.resume) {
			console.error("No resume file in form values");
			return;
		}

		// Add is_default property as a separate parameter, not attached to the file
		onSubmit({
			resume: values.resume,
			is_default: "0",
		});
	};

	return (
		<ResourceProjectFormStyled>
			<Formik
				enableReinitialize
				initialValues={formInitialValues}
				onSubmit={handleSubmit}
			>
				{(props) => {
					const { values, isSubmitting, setFieldValue } = props;
					return (
						<Form>
							<FormHeading text={title || "Upload Resume"} />
							<div
								className="row"
								data-testid={testId}
							>
								<FileUpload
									label="File"
									required="true"
									values={values}
									name="resume"
									setFieldValue={setFieldValue}
									className="col xl-12"
									multi={false}
									acceptType="application/pdf"
								/>
							</div>

							<Submit
								type="submit"
								isSubmitting={isSubmitting}
								text="Continue"
								submittingText="Processing..."
								testId={`submit-${testId}`}
							/>
						</Form>
					);
				}}
			</Formik>
		</ResourceProjectFormStyled>
	);
};
